import { InputSwitch } from 'primereact/inputswitch';
import { MultiSelect } from 'primereact/multiselect';
import { Toolbar } from 'primereact/toolbar';

const ActionButtons = ({ action, widgetFormik, dashboardListData }) => {
  const rightContent = (
    <div className="flex  gap-3 flex-column md:flex-row md:align-items-center">
      <div className="flex align-items-center gap-2">
        <span className="text-sm">Private</span>
        <InputSwitch
          checked={widgetFormik?.values?.editable}
          disabled={action !== 'create'}
          onChange={event => {
            widgetFormik.setFieldValue('editable', event.value);
          }}
        />
      </div>

      <div className="flex align-items-center gap-2">
        <i className="pi pi-chart-bar text-pink-500"></i>
        <MultiSelect
          filter
          disabled={action !== 'create'}
          value={widgetFormik?.values?.assignToDashBoardList || []}
          onChange={event => {
            widgetFormik.setFieldValue('assignToDashBoardList', event?.value);
          }}
          options={
            dashboardListData.items && dashboardListData.items.length
              ? dashboardListData.items
              : []
          }
          pt={{
            root: { className: 'w-20rem' },
            label: { className: 'p-2 text-sm' },
          }}
          optionLabel="name"
          optionValue="dashboard_id"
          display="chip"
          placeholder="Assign To Dashboard"
          maxSelectedLabels={2}
        />
      </div>
    </div>
  );
  return (
    <div className="grid grid-nogutter w-full">
      {action === 'create' && (
        <Toolbar
          className="w-full p-2"
          start={<div className="text-sm font-bold">Create Widget</div>}
          end={rightContent}
        />
      )}
    </div>
  );
};

export default ActionButtons;
